import React from 'react'
import {Outlet} from 'react-router-dom'
import SmsNav from './SmsNav'
import SmsSide from './SmsSide'

function SmsLayout() {
    return (
      
            <div className="d-flex" style={{height: "100%", overflow: "scroll", overflowX: "hidden"}}>

                <div className="d-none d-md-flex">
                    <SmsSide/>
                </div>
                <main className="flex-grow-1 p-2" style={{overflow: "scroll", overflowX: "hidden"}}>
                    <SmsNav/>
                    <Outlet/>

                </main>

            </div>
  
    )
}

export default SmsLayout